
<div class="graph">
  <div class="card">
    <div :class="['graph-container', { empty: emptyData }]">
      <line-chart
        ref="lineChart"
        :key="$route.name"
        :chart-data="chartData"
        :options="chartOptions"
      />

      <div v-show="emptyData" class="empty-text">
        {{ emptyGraphText }}
      </div>

      <full-logo v-show="!emptyData" />
    </div>
  </div>

  <align
    v-if="!hideControls"
    class="options"
    small-gap
    flex
    direction="flex-start"
  >
    <align small-gap>
      <span>{{ dateRangeText }}</span>

      <span class="date-range-container" v-if="!isPublic">
        <component
          :is="dateRangeComponent"
          v-model="dateRange"
        />
      </span>
    </align>

    <align small-gap>
      <pill-dropdown
        v-model="graphZoom"
        :options="zoomOptions"
        align="top-right"
        label="Custom"
      />

      <pill-dropdown
        v-if="!isPublic"
        v-model="graphScale"
        :options="scaleOptions"
        align="top-right"
      />
    </align>
  </align>
</div>
